module.exports = __webpack_public_path__ + "static/media/OpenSans.10bb6c19.woff";